import AppImage from '@theme/components/atom/AppImage'
import QuestionMark from '@theme/components/atom/QuestionMark'

export default {
  name: 'CategoryBox',
  components: { AppImage, QuestionMark },
  props: {
    btnText: String,
    image: String,
    status: {
      type: String,
      validator: value => ['stock', 'custom'].includes(value),
    },
    title: String,
    to: [Object, String],
  },
}
